<script setup>
  import { onMounted } from "vue"
  import Swal from "sweetalert2"
  import api from "../../api/axios.js"
  import $ from "jquery"
  import "datatables.net"
  import "datatables.net-bs5"
  import "datatables.net-bs5/css/dataTables.bootstrap5.css"
  import { useAuth } from "@/composables/useAuth";
  const { hasRole } = useAuth();

  // El link de seguimiento vive en la raíz del backend (sin /api), para que
  // sea corto al compartirlo por WhatsApp -- ver routes/quote-tracking.routes.js.
  const BACKEND_ROOT = api.defaults.baseURL.replace(/\/api\/?$/, "");

  const ESTADOS_QUOTE = [
    { value: "pendiente", label: "Pendiente" },
    { value: "enviada", label: "Enviada" },
    { value: "aceptada", label: "Aceptada" },
    { value: "rechazada", label: "Rechazada" }
  ];

  const headers = hasRole("admin")
    ? [
      "ID",
      "Usuario",
      "Fecha creación",
      "Origen",
      "Destino",
      "Fechas",
      "Pasajeros",
      "Teléfono",
      "Precio Desde",
      "Estado",
      "PDF"
    ]
    : [
      "ID",
      "Fecha creación",
      "Origen",
      "Destino",
      "Fechas",
      "Pasajeros",
      "Teléfono",
      "Precio Desde",
      "Estado",
      "PDF"
    ];

  const getDriveDownloadUrl = (url) => {
    const match = url.match(/\/d\/([^/]+)/)

    if (!match) return url

    const fileId = match[1]
    return `https://drive.google.com/uc?export=download&id=${fileId}`
  }


  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString("es-CO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
  }

  const formatCOP = (value) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value)
  }

  onMounted(() => {

    const columns = [
      {
        data: "id",
        defaultContent: ""
      }
    ];

    if (hasRole("admin")) {
      columns.push({
        data: "usuario",
        defaultContent: ""
      });
    }

    columns.push(

      {
        data: "created_at",
        defaultContent: "",
        render: function (data) {
          return data ? formatDate(data) : "";
        }
      },

      {
        data: "origin",
        defaultContent: "",
        render: function (data) {
          return getPlaceName(data);
        }
      },

      {
        data: "destination",
        defaultContent: "",
        render: function (data) {
          return getPlaceName(data);
        }
      },

      {
        data: null,
        orderable: false,
        searchable: false,
        render: function (data, type, row) {

          return `${formatDate(row.start_date)} - ${formatDate(row.end_date)}`;

        }
      },

      {
        data: "passengers",
        defaultContent: 0
      },

      {
        data: "telefono",
        defaultContent: ""
      },

      {
        data: "total_price",
        defaultContent: 0,
        render: function (data) {
          return formatCOP(data);
        }
      },

      {
        data: "status",
        orderable: false,
        searchable: false,
        defaultContent: "pendiente",
        render: function (data, type, row) {
          const opciones = ESTADOS_QUOTE.map(e =>
            `<option value="${e.value}" ${e.value === data ? "selected" : ""}>${e.label}</option>`
          ).join("");

          return `<select class="form-select form-select-sm quote-estado-select" data-id="${row.id}">${opciones}</select>`;
        }
      },

      {
        data: "pdf_url",
        orderable: false,
        searchable: false,
        defaultContent: "",
        render: function (data, type, row) {

          if (!data) {
            return "";
          }

          return `
          <div class="d-flex gap-2">

            <a href="${data}"
               target="_blank"
               class="btn btn-sm btn-primary">
              Ver PDF
            </a>

            <a href="${getDriveDownloadUrl(data)}"
               class="btn btn-sm btn-dark"
               title="Descargar PDF">

              <i class="bi bi-download"></i>

            </a>

            <button type="button"
               class="btn btn-sm btn-outline-secondary quote-copiar-link"
               data-code="${row.quote_code}"
               title="Copiar link de seguimiento">

              <i class="bi bi-link-45deg"></i>

            </button>

          </div>
        `;
        }
      }

    );

    $("#quotesTable").DataTable({

      // processing: true,
      serverSide: true,
      stateSave: true,

      pageLength: 10,

      lengthMenu: [10, 20, 50, 100],

      order: [[0, "desc"]],

      ajax: async function (data, callback) {

        try {

          const res = await api.get("/quotes/datatables", {
            params: data
          });

          callback(res.data);

        } catch (err) {

          console.error(err);

          callback({
            draw: data.draw,
            recordsTotal: 0,
            recordsFiltered: 0,
            data: []
          });

        }

      },

      columns,

      language: {
        decimal: "",
        emptyTable: "No hay datos disponibles en la tabla",
        info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
        infoEmpty: "Mostrando 0 a 0 de 0 registros",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        lengthMenu: "Mostrar _MENU_ registros",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        search: "Buscar:",
        zeroRecords: "No se encontraron resultados",
        paginate: {
          first: "<<",
          last: ">>",
          next: ">",
          previous: "<"
        }
      }

    });

    // Los <select>/<button> de estado y link de seguimiento se recrean en
    // cada redraw de DataTables -- se delega el evento sobre el contenedor
    // fijo de la tabla en vez de re-bindear cada vez.
    $("#quotesTable").on("change", ".quote-estado-select", async function () {
      const id = $(this).data("id");
      const status = $(this).val();

      try {
        await api.patch(`/quotes/${id}/status`, { status });
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "No se pudo actualizar el estado",
          text: err.response?.data?.error || "Error de conexión con el servidor."
        });
      }
    });

    $("#quotesTable").on("click", ".quote-copiar-link", async function () {
      const code = $(this).data("code");
      const link = `${BACKEND_ROOT}/q/${code}`;

      await navigator.clipboard.writeText(link);
      Swal.fire({ icon: "success", title: "Link copiado", text: link, timer: 2000, showConfirmButton: false });
    });

  });


  const placeMap = {
    // ORÍGENES
    BOG: "Bogotá",
    CLO: "Cali",
    MDE: "Medellín",
    CTG: "Cartagena",
    BAQ: "Barranquilla",
    BGA: "Bucaramanga",
    LET: "Leticia",
    AXM: "Armenia",
    PEI: "Pereira",
    PSO: "Pasto",
    PPN: "Popayán",
    SMR: "Santa Marta",
    MTR: "Montería",
    RCH: "Riohacha",
    MVP: "Mitú",
    IBE: "Ibagué",
    NVA: "Neiva",
    CUC: "Cúcuta",
    MZL: "Manizales",

    // DESTINOS
    PUJ: "Punta Cana",
    BKK: "Tailandia",
    CUN: "Cancún",
    GIG: "Brasil",
    PERU: "Perú",
    AUA: "Aruba",
    CUR: "Curazao",
    MBJ: "Jamaica",
    PTY: "Panamá (Playa)",
    PTYC: "Ciudad de Panamá",
    VRA: "Varadero",
    HAV: "La Habana",
    PCM: "Playa del Carmen",
    MEX: "Ciudad de México",
    JPN: "Japón",
    "JPN GUIA": "Japón (con guía)",
    SJD: "Los Cabos",
    ADZ: "San Andrés",
    "PTY COMBINADO": "Panamá (combinado)",
    "HAV COMBINADO": "La Habana (combinado)",
    "MEX COMBINADO": "México (combinado)",
    DECAMERON: "Decameron",
  };

  const getPlaceName = (code) => placeMap[code] || code;
</script>


<template>
  <div>

    <div class="card shadow-sm">

      <div class="card-header pb-0">
        <h5 class="mb-0">
          <i class="bi bi-list-ul me-2"></i>
          Cotizaciones
        </h5>
      </div>

      <div class="card-body">

        <div class="table-responsive">

          <table id="quotesTable" class="table table-striped table-bordered align-middle w-100">
            <thead class="table-dark">
              <tr>
                <th v-for="header in headers" :key="header">
                  {{ header }}
                </th>
              </tr>
            </thead>

            <tbody>

            </tbody>
          </table>

        </div>

      </div>

    </div>

  </div>
</template>